var skrillProfile = null;

function reqListener() {
	skrillProfile = JSON.parse(this.responseText);
	if (
		skrillProfile &&
		!!skrillProfile.customerProfile &&
		skrillProfile.customerProfile.id &&
		document.querySelector("header li.sub.user .firstname")
	) {
		document.querySelector("header li.sub.user .firstname").innerHTML = skrillProfile.customerProfile.firstName;
		document.querySelector("header li.sub.user .email").innerHTML = skrillProfile.customerProfile.email;
		document.querySelector("header").classList.add("logged-in");
	} else {
		document.querySelector("header").classList.add("not-logged-in");
	}
}

function reqError() {
	document.querySelector("header").classList.add("not-logged-in");
}
var oReq = new XMLHttpRequest();
oReq.onload = reqListener;
oReq.onerror = reqError;
oReq.open("GET", "https://" + location.hostname + "/api/login/authorize?include=profile");
oReq.withCredentials = true;
oReq.setRequestHeader("Content-Type", "application/json");
oReq.send();

function logout() {
	function reqListener() {
		location.reload();
	}
	var oReq = new XMLHttpRequest();
	oReq.onload = reqListener;
	oReq.open("POST", "https://" + location.hostname + "/api/logout/v1/logouts");
	oReq.withCredentials = true;
	oReq.setRequestHeader("Content-Type", "application/json");
	oReq.setRequestHeader("x-xsrf-token", document.cookie.match(new RegExp("(^| )XSRF-TOKEN=([^;]+)"))[2]);
	oReq.send(
		JSON.stringify({
			username: skrillProfile.customerProfile.email,
			applicationName: skrillProfile.applicationName,
			brand: skrillProfile.brand,
			userId: skrillProfile.customerProfile.id
		})
	);
}
if (typeof referrer_value !== "undefined" && referrer_value && document.querySelector("#content > .referrer")) {
	document.querySelector("#content > .referrer").classList.remove("referrer");
}
